import { useFetch } from '../api/FetchApiData';
import { isMobile } from 'react-device-detect';
//import WsNotifications from '../api/WsNotifications';
//import WsPositionSharing from '../api/WsPositionSharing';
import { useContext,useEffect,useState, useCallback } from 'react';
import { UserContext } from '../../AppContextProvider';
import Popup from 'reactjs-popup';
import { useNavigate } from 'react-router-dom';
import { useInfiniteScroll } from '../utils/InfiniteScroll';
import notificationsIcon from '../icons/notification.png';
import _notificationsIcon from '../icons/notification_browser.png';

const Notification = ({notification,isOpened = false, close=()=>{}})=>{
    const [_notification,setNotification] = useState(notification);
    const [decoration,setDecoration] = useState({color:'gray',weight:'normal'});
    const navigator = useNavigate();

    useEffect(()=>{
        if(!_notification.is_read)
            setDecoration({color:'black',weight:'bold'});
        else
           setDecoration({color:'gray',weight:'normal'});
    },[notification.is_read])

    const CustomerSharePosition=()=>{
        /*
        if(!!_notification.meta)
        {
            const data = {deliver_id:_notification.meta.deliver_id,accept:true,sender:'customer'};
            WsPositionSharing.sender = "customer";
            WsPositionSharing.send(data);
            if(!WsPositionSharing.is_sharing)
                WsPositionSharing.ShareByTimer();
        }
        close();
        */
    }

    const trackOrders = ()=>{
        close();
        navigator('/user/tracking/orders/');
    }

    return(
        <div style={{display:'block',margin:'auto',textAlign:'left',borderBottom:'1px solid lightgray',margin:'5px',borderRadius:'5px',padding:'10px'}}>
            <label style={{display:'block',fontSize:'x-small',color:'gray'}}>{notification.created_at}</label>
            <label style={{display:'block',fontSize:'small',marginTop:'5px'}}>{notification.comment}</label>
            {(notification.type==='tracking_order') &&
            <div style={{display:'block',textAlign:'right'}}>
                <input onClick={e=>{trackOrders()}} style={{fontSize:'small',padding:'8px 15px 10px 15px',border:'none',backgroundColor:'blue',color:'white',borderRadius:'3px'}} type='button' value={'Suivre'} />
            </div>}
            {(notification.type==='pos_request') &&
            <div style={{display:'block',textAlign:'right'}}>
                <input onClick={e=>{CustomerSharePosition()}} style={{fontSize:'small',padding:'5px 15px 7px 15px',marginTop:'5px',border:'none',backgroundColor:'lightblue',color:'black',borderRadius:'3px'}} type='button' value={'Accepter'} />
            </div>}
        </div>
    )
}


export const Notifications = ({})=>{

    const [UserState, setUserState] = useContext(UserContext);
    const fetchData = useFetch();
    const [notifications,setNotifications] = useState([]);
    const [notifsCounter,setNotifCounter] = useState(UserState.notifs_counter);
    const [isOpened,setIsOpened] = useState(false);
    const [hasMore,setHasMore] = useState(true);
    const [page,setPage] = useState(1);

    const onNotification = (data)=>{
        if(!!data.user_profile)
        {
            setUserState({...data.user_profile});
            //if(!isOpened)
                //setNotifCounter(data['profile'].notifs_counter);
            
        }
        if(!!data['notification'])
        {   
            notifications.push(data.notification);
            setNotifications([...notifications]);
        }
    }

    useEffect(()=>{setNotifCounter(UserState.notifs_counter)},[UserState.notifs_counter])

    const FetchNotifications = useCallback(async ()=>{
        if (!hasMore || !isOpened)
            return
        let params = new URLSearchParams({
            page:page,
        });
        fetchData.GetData(`user/notification/?${params}`).then((result)=>{
            console.log(result);
            if(result.result)
            {
                if(page>result.max)
                    setHasMore(false);
                else
                {
                    setNotifications([...notifications,...result.notifications]);
                    setPage(prev=>prev+1);
                }
            }
        });
        
    },[page, hasMore, isOpened])

    const LoadMoreRef = useInfiniteScroll(FetchNotifications,hasMore);
    
    useEffect(()=>{
        //WsNotifications.onMessage(onNotification)
    },[])

    const SetNotifsAsRead = ()=>{    
        const arr = []; 
        notifications.map((not)=>{
            arr.push(not.id);
        });
        fetchData.PutData({notifications:arr},'user/notification/').then((result)=>{
            if(result.result)
            {
                setNotifCounter(result.counter);
                for(var i=0;i++;i<notifications.length)
                    notifications[i].is_read = true
                setNotifications([...notifications]);
            }
        })
    }

    useEffect(()=>{
        if(!isOpened)
        {
            setPage(1);
            setNotifications([]);
        }
        /*
        if(UserState.auth && isOpened)
        {
            fetchData.GetData('user/notification/').then((result)=>{
                console.log(result);
                if(result.result)
                {
                    setNotifications([...result.notifications]);
                    setNotifCounter(result.counter)
                }
            })
        }
        */
    },[isOpened])



    if(isMobile)
    {
        return(
            <Popup onOpen={e=>{setIsOpened(true);}} onClose={e=>{setIsOpened(false);SetNotifsAsRead();}} trigger={
                <div className="btn-nav" style={{display:'inline-block'}}>
                    <img style={{width:'100%'}} onClick={e=>{}}  src={notificationsIcon}  alt="navigation"/>
                    {(UserState.notifs_counter>0) && <span id="notif" style={{top:'10px'}} onClick={e=>{}}>
                        {UserState.notifs_counter}
                    </span>
                    }
                </div>
            }>
            {close=>(
                <div className='footer-pop-screen' style={{height:'100vh'}} onClick={()=>{}}>
                    <fieldset className='notifications-fieldset'>
                        <legend style={{width:'100%',paddingTop:'7px',backgroundColor:'goldenrod',height:'25px',borderRadius:'5px'}}>Notifications</legend>
                        <div style={{display:'flex',flexDirection:'column',width:'100%'}}>
                            {(notifications.length>0) && notifications.map((notif,index)=>{
                                return <Notification key={index} isOpened={isOpened} notification={notif} close={close} />;
                            })}
                        </div>
                        {(notifications.length===0) && 
                            <div style={{display:'block',margin:'auto',textAlign:'center',margin:'5px',borderRadius:'5px',padding:'10px'}}>
                                <label style={{color:'gray'}}>Aucune notification</label>
                            </div>
                        }
                        <div ref={LoadMoreRef} style={{height:'20px'}}/>
                    </fieldset>
                </div>)}
            </Popup>
        )
    }
    else
    {
        return(
            <li className="Controls-li">
                <div id="li-contact" className="controls-li-div">
                    <div>
                        <img id="img-contact" src={_notificationsIcon} style={{width:"18px",verticalAlign:"middle",marginLeft:"5px"}}  />
                        <span style={{marginLeft:'-8px',Top:'-5px',fontSize:'small',backgroundColor:"rgb(255,0,0,0.8)",paddingLeft:"5px",paddingRight:"5px",borderRadius:'1px',verticalAlign:'top'}}>
                            {notifsCounter}
                        </span>
                    </div>
                    <span className="labelname" onClick={e=>{}}>Notifications</span>
                </div>
                <div className="SubControls" style={{width:'300px'}}>
                    <fieldset id="SubControlsFieldSet">
                        <legend className="triangle"></legend>
                        <ul className="SubControls-ul">
                            {(notifications.length===0) && 
                                <div style={{display:'block',margin:'auto',textAlign:'center',margin:'5px',borderRadius:'5px',padding:'0px'}}>
                                    <label style={{color:'gray'}}>Aucune notification</label>
                                </div>
                            }
                            {notifications.map((notif,index)=>{
                                return(<Notification key={index} notification={notif} />);
                            })}
                            <div ref={LoadMoreRef} style={{height:'20px'}}/>
                        </ul>
                    </fieldset>
                </div>
            </li>
        );
    }
}